import HeroFold from './HeroFold';

export default HeroFold;
